exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".styles--cSwitch__3lyhS{display:inline-block}.styles--cSwitchMargin__2XANr{margin-top:3px;vertical-align:middle}.styles--switcher__24rl0{display:block;width:28px;height:14px;border-radius:20px;position:relative;-webkit-transition:all 0.3s ease-out;transition:all 0.3s ease-out;background-color:#dcdcdc;margin:0;padding:0}.styles--switcher__24rl0:before{content:\"\";display:block;width:16px;height:16px;background-color:#fff;border:2px solid #99b2c6;border-radius:50%;position:absolute;right:12px;top:-1px;-webkit-box-sizing:border-box;box-sizing:border-box;-webkit-transition:all 0.3s ease-out;transition:all 0.3s ease-out}.styles--active__2aZOr{background-color:#a6d4b1}.styles--active__2aZOr:before{right:0}.styles--note__3IurJ{display:block}\n", ""]);

// exports
exports.locals = {
	"cSwitch": "styles--cSwitch__3lyhS",
	"cSwitchMargin": "styles--cSwitchMargin__2XANr",
	"switcher": "styles--switcher__24rl0",
	"active": "styles--active__2aZOr",
	"note": "styles--note__3IurJ"
};